const noop=()=>{},noopReturn=v=>v;export{noop,noopReturn};